import { render } from "./DoctorItem.vue?vue&type=template&id=a8c79b90&scoped=true&ts=true"
import script from "./DoctorItem.vue?vue&type=script&lang=ts"
export * from "./DoctorItem.vue?vue&type=script&lang=ts"

import "./DoctorItem.vue?vue&type=style&index=0&id=a8c79b90&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\HESEL\\DCS\\Client\\vuejs-dcs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8c79b90"]])

export default __exports__